import { change } from 'redux-form';
import _ from 'lodash';

import { success, loading, handleErrorException } from 'State/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import {
  ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME,
  ASSIGN_ENTITIES_FORM_NAME,
} from 'Common/FormEnum';
import {
  SiteEnum,
  SiteGroupEnum,
  ItemEnum,
  AssignEntitiesEnum,
  FilterEnum,
} from 'Common/FieldEnum';
import { OrderPreferenceIdEnum } from 'Common/Constants/Enumeration/OrderPreferenceEnum';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import {
  getCheckedData,
  reOrderItemList,
  reOrderSiteGroupList,
  getAssignEntitiesURL,
  reOrderSiteList,
  reOrderStorageLocationItems,
  reOrderUserList,
  reOrderAssignEntitiesSiteList,
  reOrderSiteGroupListForStorageLocation,
  reOrderAssignEntitiesSiteIds,
  reOrderSiteGroupIds,
} from '../../helper/assignEntities';
import * as types from './types';

export const getSiteGroupData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ASSIGN_ENTITIES_SITE_GROUP_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        'AssignEntities/GetSiteGroups'
      );
      dispatch(
        success(types.ASSIGN_ENTITIES_SITE_GROUP_DATA, response.data.Data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching site groups. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ASSIGN_ENTITIES_SITE_GROUP_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ASSIGN_ENTITIES_SITE_GROUP_LOADING, false));
    }
  };
};

export const getItemsBySiteId = SiteId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ASSIGN_ENTITIES_GET_ITEMS_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `AssignEntities/GetItemsBySiteId/${SiteId}`
      );
      dispatch(
        success(types.ASSIGN_ENTITIES_GET_ITEMS_DATA, response.data.Data.Data)
      );
      if (response.data.Data.Data) {
        const initialValues = getCheckedData(
          response.data.Data.Data,
          ItemEnum.CheckBox
        );
        dispatch(
          change(
            ASSIGN_ENTITIES_FORM_NAME,
            AssignEntitiesEnum.ItemGridInfo,
            initialValues
          )
        );
        dispatch({
          type: types.SET_ITEMS_BY_SITE_ID,
          payload: initialValues,
        });
        const data = reOrderItemList(response.data.Data.Data);
        data && data.length && dispatch(reOrderList(data));
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching items. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ASSIGN_ENTITIES_GET_ITEMS_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ASSIGN_ENTITIES_GET_ITEMS_LOADING, false));
    }
  };
};

export const getItemsBySiteGroupId = SiteGroupId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ASSIGN_ENTITIES_GET_ITEMS_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `AssignEntities/GetItemsBySiteGroup/${SiteGroupId}`
      );
      dispatch(
        success(types.ASSIGN_ENTITIES_GET_ITEMS_DATA, response.data.Data.Data)
      );

      if (response.data.Data.Data) {
        const checkedData = getCheckedData(
          response.data.Data.Data,
          ItemEnum.CheckBox
        );
        dispatch(
          change(
            ASSIGN_ENTITIES_FORM_NAME,
            AssignEntitiesEnum.ItemGridInfo,
            checkedData
          )
        );
        dispatch({
          type: types.SET_ITEMS_BY_SITE_GROUP_ID,
          payload: checkedData,
        });
        const data = reOrderItemList(response.data.Data.Data);
        data && data.length && dispatch(reOrderList(data));
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching items. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ASSIGN_ENTITIES_GET_ITEMS_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ASSIGN_ENTITIES_GET_ITEMS_LOADING, false));
    }
  };
};

export const clearSubmitError = () => {
  return {
    type: types.CLEAR_SUBMIT_ERROR,
  };
};

export const reOrderList = items => {
  return dispatch => {
    dispatch({
      type: types.RE_ORDER_ITEM_LIST,
      payload: items,
    });
    dispatch(resetDirty());
  };
};

export const reOrderUsers = users => {
  return dispatch => {
    dispatch({
      type: types.RE_ORDER_USERS_LIST,
      payload: users,
    });
    dispatch(resetDirty());
  };
};

export const reOrderSiteGroup = siteGroups => {
  return dispatch => {
    dispatch({
      type: types.RE_ORDER_SITE_GROUPS,
      payload: siteGroups,
    });
    dispatch(resetDirty());
  };
};

export const reOrderSites = sites => {
  return dispatch => {
    dispatch({
      type: types.RE_ORDER_SITES,
      payload: sites,
    });
    dispatch(resetDirty());
  };
};

export const reOrderStorageLocationItemList = items => {
  return dispatch => {
    dispatch({
      type: types.RE_ORDER_ITEM_LIST,
      payload: items,
    });
    dispatch(resetDirty());
  };
};

export const getAllSites = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric('SiteMaster/?allSites=true');
      dispatch(
        success(types.ASSIGN_ENTITIES_ALL_SITES_DATA, response.data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching sites. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING, false));
    }
  };
};

export const getSiteSiteGrpItemByStorageLoc = storageLocationID => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CLEAR_STORAGE_LOCATION_LOADING_ERROR, true));
    dispatch(loading(types.GET_STORAGE_LOCATION_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(`AssignEntities/GetSiteSiteGrpItemByStorageLoc/${storageLocationID}
`);
      if (response.data.Data.Data) {
        const { ItemIds, SiteIds, SiteGroups } = response.data.Data.Data;
        dispatch({
          type: types.SET_STORAGE_LOCATION_ASSIGNED_DATA,
          payload: {
            [AssignEntitiesEnum.ItemGridInfo]: ItemIds,
            [AssignEntitiesEnum.SiteGridInfo]: SiteIds,
            [AssignEntitiesEnum.SiteGroupGridInfo]: SiteGroups,
          },
        });
        dispatch(
          change(
            ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME,
            AssignEntitiesEnum.ItemGridInfo,
            ItemIds
          )
        );
        dispatch(
          change(
            ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME,
            AssignEntitiesEnum.SiteGridInfo,
            SiteIds
          )
        );
        dispatch(
          change(
            ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME,
            AssignEntitiesEnum.SiteGroupGridInfo,
            SiteGroups
          )
        );
        const {
          allItemsData,
          allSitesData,
          siteGroupData,
        } = getState().UtilitiesState.assignEntities;
        if (ItemIds.length) {
          const sortedData = reOrderStorageLocationItems(ItemIds, allItemsData);
          sortedData && dispatch(reOrderStorageLocationItemList(sortedData));
        }
        if (SiteIds.length) {
          const sortedData = reOrderSiteList(allSitesData, SiteIds);
          sortedData && dispatch(reOrderSites(sortedData));
        }
        if (SiteGroups.length) {
          const sortedData = reOrderSiteGroupListForStorageLocation(
            siteGroupData,
            SiteGroups
          );
          sortedData && dispatch(reOrderSiteGroup(sortedData));
        }
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching storage location data. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.GET_STORAGE_LOCATION_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.GET_STORAGE_LOCATION_LOADING, false));
    }
  };
};

export const getSitesByItemId = ItemId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `AssignEntities/GetSitesByItemId/${ItemId}`
      );
      let assignedSites = response.data.Data.Data;
      if (assignedSites) {
        assignedSites = assignedSites.length
          ? assignedSites.map(site => {
              site[SiteEnum.CheckBox] = true;
              return site;
            })
          : [];
        dispatch({
          type: types.SET_SITES_BY_ITEM_ID,
          payload: assignedSites,
        });
        dispatch(
          change(
            ASSIGN_ENTITIES_FORM_NAME,
            AssignEntitiesEnum.SiteGridInfo,
            assignedSites
          )
        );
        const { allSitesData } = getState().UtilitiesState.assignEntities;
        if (assignedSites.length) {
          const sortedData = reOrderAssignEntitiesSiteList(
            allSitesData,
            assignedSites
          );
          sortedData && dispatch(reOrderSites(sortedData));
        }
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching all sites. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING, false));
    }
  };
};

export const getSiteGroupByItemId = ItemId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ASSIGN_ENTITIES_SITE_GROUP_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `AssignEntities/GetSiteGroupByItemId/${ItemId}`
      );
      const siteGrpData = response.data.Data.Data;
      if (siteGrpData) {
        const assignedData = siteGrpData.length
          ? siteGrpData.map(siteGrp => {
              siteGrp[SiteGroupEnum.CheckBox] = true;
              siteGrp[SiteGroupEnum.SiteModel] = siteGrp[
                SiteGroupEnum.SiteModel
              ].map(site => {
                site[SiteEnum.OrderPreferenceName] =
                  OrderPreferenceIdEnum[site[SiteEnum.OrderPreferenceId]];
                return site;
              });
              return siteGrp;
            })
          : [];
        dispatch({
          type: types.SET_SITE_GROUPS_BY_ITEM_ID,
          payload: assignedData,
        });
        dispatch(
          change(
            ASSIGN_ENTITIES_FORM_NAME,
            AssignEntitiesEnum.SiteGroupGridInfo,
            assignedData
          )
        );
        const { siteGroupData } = getState().UtilitiesState.assignEntities;
        if (assignedData.length) {
          const sortedData = reOrderSiteGroupList(siteGroupData, assignedData);
          sortedData && dispatch(reOrderSiteGroup(sortedData));
        }
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching site groups. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ASSIGN_ENTITIES_SITE_GROUP_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ASSIGN_ENTITIES_SITE_GROUP_LOADING, false));
    }
  };
};

export const getItems = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ASSIGN_ENTITIES_GET_ITEMS_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(`AssignEntities/GetItems`);
      dispatch(
        success(types.ASSIGN_ENTITIES_GET_ITEMS_DATA, response.data.Data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching items. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ASSIGN_ENTITIES_GET_ITEMS_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ASSIGN_ENTITIES_GET_ITEMS_LOADING, false));
    }
  };
};

export const getUsers = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ASSIGN_ENTITIES_GET_USERS_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(`AssignEntities/GetUsers`);
      dispatch(
        success(types.ASSIGN_ENTITIES_GET_USERS_DATA, response.data.Data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching items. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ASSIGN_ENTITIES_GET_USERS_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ASSIGN_ENTITIES_GET_USERS_LOADING, false));
    }
  };
};

export const getUsersBySiteId = siteId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ASSIGN_ENTITIES_GET_USERS_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `AssignEntities/GetUsersBySiteId/${siteId}`
      );

      if (response.data.Data.Data) {
        let selectedUserName = response.data.Data.Data
          ? _.map(response.data.Data.Data, 'UserName')
          : [];
        dispatch(
          change(
            ASSIGN_ENTITIES_FORM_NAME,
            AssignEntitiesEnum.UserGridInfo,
            selectedUserName
          )
        );
        dispatch({
          type: types.SET_USERS_BY_SITE_ID,
          payload: selectedUserName,
        });
        const { allUsersData } = getState().UtilitiesState.assignEntities;
        if (selectedUserName.length) {
          const sortedData = reOrderUserList(allUsersData, selectedUserName);
          sortedData && dispatch(reOrderUsers(sortedData));
        }
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching users. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ASSIGN_ENTITIES_GET_USERS_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ASSIGN_ENTITIES_GET_USERS_LOADING, false));
    }
  };
};

export const getUsersBySiteGroupId = siteGroupId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ASSIGN_ENTITIES_GET_USERS_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `AssignEntities/GetUsersBySiteGroup/${siteGroupId}`
      );
      if (response.data.Data.Data) {
        let selectedUserName = response.data.Data.Data
          ? _.map(response.data.Data.Data, 'UserName')
          : [];
        dispatch(
          change(
            ASSIGN_ENTITIES_FORM_NAME,
            AssignEntitiesEnum.UserGridInfo,
            selectedUserName
          )
        );
        dispatch({
          type: types.SET_USERS_BY_SITE_GROUP_ID,
          payload: selectedUserName,
        });
        const { allUsersData } = getState().UtilitiesState.assignEntities;
        if (selectedUserName.length) {
          const sortedData = reOrderUserList(allUsersData, selectedUserName);
          sortedData && dispatch(reOrderUsers(sortedData));
        }
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching users. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ASSIGN_ENTITIES_GET_USERS_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ASSIGN_ENTITIES_GET_USERS_LOADING, false));
    }
  };
};

export const clearUserData = () => {
  return {
    type: types.ASSIGN_ENTITIES_CLEAR_USER_DATA,
  };
};

export const getSitesByUserName = userName => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `AssignEntities/GetSiteIdsByUserName/${userName}`
      );

      if (response.data.Data.Data) {
        const assignedData =
          Array.isArray(response.data.Data.Data) &&
          response.data.Data.Data.length
            ? _.map(response.data.Data.Data, site => {
                return site.Id;
              })
            : [];
        dispatch({
          type: types.SET_SITES_BY_USER_NAME,
          payload: assignedData,
        });
        dispatch(
          change(
            ASSIGN_ENTITIES_FORM_NAME,
            AssignEntitiesEnum.SiteGridInfo,
            assignedData
          )
        );

        const { allSitesData } = getState().UtilitiesState.assignEntities;
        if (assignedData.length) {
          const sortedData = reOrderAssignEntitiesSiteIds(
            allSitesData,
            assignedData
          );
          sortedData && dispatch(reOrderSites(sortedData));
        }
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching all sites. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING, false));
    }
  };
};

export const getSiteGroupsByUserName = userName => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `AssignEntities/GetSiteGroupsByUserName/${userName}`
      );
      if (response.data.Data.Data) {
        const assignedData =
          Array.isArray(response.data.Data.Data) && response.data.Data.Data
            ? _.map(response.data.Data.Data, site => {
                return site.Id;
              })
            : [];
        dispatch({
          type: types.SET_SITE_GROUPS_BY_USER_NAME,
          payload: assignedData,
        });

        dispatch(
          change(
            ASSIGN_ENTITIES_FORM_NAME,
            AssignEntitiesEnum.SiteGroupGridInfo,
            assignedData
          )
        );

        const { siteGroupData } = getState().UtilitiesState.assignEntities;
        if (assignedData.length) {
          const sortedData = reOrderSiteGroupIds(siteGroupData, assignedData);
          sortedData && dispatch(reOrderSiteGroup(sortedData));
        }
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching all sites. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.ASSIGN_ENTITIES_GET_ALL_SITES_LOADING, false));
    }
  };
};

export const saveAssignEntities = (payload, assignAction) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SUBMITTING_ASSIGN_ENTITIES, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        getAssignEntitiesURL(assignAction),
        payload
      );
      dispatch(resetDirty());
      dispatch(success(types.SUBMITTED_ASSIGN_ENTITIES, response));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while assigning site group to items. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.SUBMITTING_ASSIGN_ENTITIES_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.SUBMITTING_ASSIGN_ENTITIES, false));
    }
  };
};

export const resetAssignEntitiesPage = (leftGridData, rightGridData) => {
  return dispatch => {
    //first reset all grid values
    dispatch(
      change(ASSIGN_ENTITIES_FORM_NAME, AssignEntitiesEnum.ItemGridInfo, [])
    );
    dispatch(
      change(ASSIGN_ENTITIES_FORM_NAME, AssignEntitiesEnum.SiteGridInfo, [])
    );
    dispatch(
      change(
        ASSIGN_ENTITIES_FORM_NAME,
        AssignEntitiesEnum.SiteGroupGridInfo,
        []
      )
    );
    dispatch(
      change(ASSIGN_ENTITIES_FORM_NAME, AssignEntitiesEnum.UserGridInfo, [])
    );

    //set current grid initial values
    dispatch(
      change(ASSIGN_ENTITIES_FORM_NAME, leftGridData.name, leftGridData.value)
    );
    dispatch(
      change(ASSIGN_ENTITIES_FORM_NAME, rightGridData.name, rightGridData.value)
    );
  };
};

export const setSiteGridInfo = SiteGridInfo => {
  return dispatch => {
    dispatch(
      change(
        ASSIGN_ENTITIES_FORM_NAME,
        AssignEntitiesEnum.SiteGridInfo,
        SiteGridInfo
      )
    );
  };
};

export const clearItemGridFilter = () => {
  return dispatch => {
    dispatch(
      change(
        ASSIGN_ENTITIES_FORM_NAME,
        FilterEnum.GroupId_Item,
        GenericEnum.InitialFilterValue
      )
    );
    dispatch(
      change(
        ASSIGN_ENTITIES_FORM_NAME,
        FilterEnum.GroupId_Bid,
        GenericEnum.InitialFilterValue
      )
    );
    dispatch(
      change(
        ASSIGN_ENTITIES_FORM_NAME,
        FilterEnum.GroupId_Cat,
        GenericEnum.InitialFilterValue
      )
    );
    dispatch(
      change(
        ASSIGN_ENTITIES_FORM_NAME,
        FilterEnum.VendorId,
        GenericEnum.InitialFilterValue
      )
    );
    dispatch(
      change(
        ASSIGN_ENTITIES_FORM_NAME,
        FilterEnum.GroupId_Location,
        GenericEnum.InitialFilterValue
      )
    );
    dispatch(
      change(ASSIGN_ENTITIES_FORM_NAME, FilterEnum.PrepareInHouse, false)
    );
  };
};

export const resetAssignEntitiesStoragePage = assignedStorageLocationData => {
  return dispatch => {
    dispatch(
      change(
        ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME,
        AssignEntitiesEnum.ItemGridInfo,
        assignedStorageLocationData[AssignEntitiesEnum.ItemGridInfo]
      )
    );
    dispatch(
      change(
        ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME,
        AssignEntitiesEnum.SiteGridInfo,
        assignedStorageLocationData[AssignEntitiesEnum.SiteGridInfo]
      )
    );
    dispatch(
      change(
        ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME,
        AssignEntitiesEnum.SiteGroupGridInfo,
        assignedStorageLocationData[AssignEntitiesEnum.SiteGroupGridInfo]
      )
    );
  };
};

export const clearAssignedStorageLocationData = () => {
  return {
    type: types.SET_STORAGE_LOCATION_ASSIGNED_DATA,
    payload: {
      ItemGridInfo: [],
      SiteGridInfo: [],
      SiteGroupGridInfo: [],
    },
  };
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/assignEntities/actions.js